import { createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-3 gap-3 sm:gap-2"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center text-gray-400 text-sm py-10"
}
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-3 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-1.5 sm:gap-2"
}
const _hoisted_5 = { class: "grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-1.5 sm:gap-2" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "text-white text-[10px]" }
const _hoisted_8 = { class: "absolute z-10 top-0 right-0 flex justify-center items-center w-max px-0.5" }
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = {
  class: "relative z-0 top-0 left-0 group w-full h-full",
  tabindex: "0"
}
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 0,
  class: "absolute z-10 top-0 left-0 hidden group-hover:flex group-focus:flex group-active:flex justify-center items-center w-full h-full bg-black/50"
}
const _hoisted_13 = ["onClick", "title"]
const _hoisted_14 = {
  key: 1,
  class: "absolute z-10 top-0 left-0 hidden flex justify-center items-center w-full h-full bg-black/50"
}
const _hoisted_15 = ["title"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" Search box "),
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      class: "max-w-md mx-auto"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.search) = $event)),
          type: "search",
          id: "search",
          class: "block w-full p-4 ps-10 text-sm border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500",
          placeholder: "ค้นหาเกมที่คุณชอบ..."
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.search]
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
          _createElementVNode("svg", {
            class: "w-5 h-5 text-gray-500",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M21 21l-4.35-4.35m0 0A7.5 7.5 0 1 0 3 10.5a7.5 7.5 0 0 0 13.65 6.15z"
            })
          ])
        ], -1 /* HOISTED */))
      ])
    ], 32 /* NEED_HYDRATION */),
    (_ctx.loadingGames)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (n) => {
            return _createElementVNode("div", {
              key: 'game-skeleton-' + n,
              class: "h-32 sm:h-36 md:h-32 xl:h-40 bg-gray-200 animate-pulse rounded"
            })
          }), 64 /* STABLE_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Empty message "),
    (_ctx.gamesList.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " ยังไม่มีเกมที่คุณชื่นชอบ "))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createCommentVNode(" Games "),
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex items-center justify-between w-full mb-2" }, [
              _createElementVNode("h3", { class: "text-lg text-gray-800 font-semibold" }, "รายการเกม")
            ], -1 /* HOISTED */)),
            _createCommentVNode(" Games Loading "),
            (_ctx.loadingGames)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (n) => {
                    return _createElementVNode("div", {
                      key: 'game-skeleton-' + n,
                      class: "h-32 md:h-32 xl:h-36 2xl:h-40 bg-gray-200 animate-pulse rounded"
                    })
                  }), 64 /* STABLE_FRAGMENT */))
                ]))
              : (_ctx.gamesList.length === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Games Empty "),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-gray-400 italic" }, "ไม่พบข้อมูลเกม", -1 /* HOISTED */))
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createCommentVNode(" Games List "),
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gamesList, (game) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: game.loginCode,
                          class: "relative z-0 h-32 md:h-32 xl:h-36 2xl:h-40 w-full border rounded shadow-sm transition hover:bg-primary hover:text-primary overflow-hidden!"
                        }, [
                          _createElementVNode("div", {
                            class: "absolute z-10 top-0 left-0 flex justify-center items-center w-max gap-1 bg-black/60 rounded-br px-0.5 cursor-default",
                            title: 'กำลังเล่นอยู่: ' + (game?.online || 0)
                          }, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "relative flex size-2" }, [
                              _createElementVNode("span", { class: "absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" }),
                              _createElementVNode("span", { class: "relative inline-flex size-2 rounded-full bg-green-500" })
                            ], -1 /* HOISTED */)),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(game?.online || 0), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_6),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", {
                              onClick: $event => (_ctx.clickBtnFavorite(game?.loginCode || '', game?.isFavorite || false)),
                              title: !game.isFavorite ? 'เพิ่มลงรายการโปรด': 'ลบออกจากรายการโปรด'
                            }, [
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(["size-6 drop-shadow cursor-pointer hover:text-pink-600", {'text-white': game.isFavorite === false, 'text-pink-600': game.isFavorite === true}]),
                                "aria-hidden": "true",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                fill: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("path", { d: "m12.75 20.66 6.184-7.098c2.677-2.884 2.559-6.506.754-8.705-.898-1.095-2.206-1.816-3.72-1.855-1.293-.034-2.652.43-3.963 1.442-1.315-1.012-2.678-1.476-3.973-1.442-1.515.04-2.825.76-3.724 1.855-1.806 2.201-1.915 5.823.772 8.706l6.183 7.097c.19.216.46.34.743.34a.985.985 0 0 0 .743-.34Z" }, null, -1 /* HOISTED */)
                              ]))], 2 /* CLASS */))
                            ], 8 /* PROPS */, _hoisted_9)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("img", {
                              class: _normalizeClass(["static z-0 w-full h-full top-0 left-0", {'group-hover:grayscale': game.active, 'grayscale': !game.active }]),
                              src: game.logo?.vertical,
                              alt: game.gameName?.toLocaleUpperCase()
                            }, null, 10 /* CLASS, PROPS */, _hoisted_11),
                            (game.active)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("button", {
                                    onClick: $event => (_ctx.clickGame(game?.loginCode || '')),
                                    title: 'เล่น '+game.gameName?.toLocaleUpperCase(),
                                    type: "button",
                                    class: "w-16 text-white text-xs font-semibold bg-yellow-400 rounded-lg py-1 shadow cursor-pointer"
                                  }, "เล่น", 8 /* PROPS */, _hoisted_13)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[6] || (_cache[6] = [
                                  _createElementVNode("span", { class: "text-xs font-bold" }, "ปิดปรับปรุง", -1 /* HOISTED */)
                                ]))]))
                          ]),
                          _createElementVNode("h4", {
                            title: game.gameName?.toLocaleUpperCase(),
                            class: "absolute z-10 bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-[11px] font-semibold truncate bg-black/60 px-1 cursor-default"
                          }, _toDisplayString(game.gameName?.toUpperCase()), 9 /* TEXT, PROPS */, _hoisted_15)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ]))
}